var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"proa-tooltip-wrapper",on:{"mouseover":_vm.onMouseOver,"mouseleave":_vm.onMouseLeave}},[(_vm.showTooltip)?_c('div',{staticClass:"proa-tooltip"},[_vm._t("tooltip")],2):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }